module.exports = __webpack_public_path__ + "img/platform_md_sub.db22cb28.png";